module.exports = __webpack_public_path__ + "static/media/shapes-square-line.ebc250c1.svg";